"use client";


import { signIn } from '@/lib/actions/user.actions';
import React, { useEffect } from 'react'

function CheckAutomaticLogin({searchParams}: {searchParams: { username: string, hashed_password:string }}) {

  const { username, hashed_password } = searchParams;
  const check = async() => {

  if (username && hashed_password) {
    console.log('SignIn/automatic signin');
    try {
      const userData = {
        username: username,
        password: hashed_password,
        url: "/api/automatic_login/",
      };
      await signIn(userData);
    } catch (err) {
      console.error('AuthForm/onSubmit', err);
    }
  }}

  useEffect(() => {
    check();
  }, [])

  return (
    <div> </div>
  )
}

export default CheckAutomaticLogin